import { useContext, useEffect } from 'react';
import context from './context';

const useHelpKeywords = (newKeywords?: string | string[]) => {
  const { keywords, setKeywords, unsetKeywords } = useContext(context);
  useEffect(() => {
    if (!newKeywords) {
      return;
    }
    const kw = typeof newKeywords === 'string' ? [newKeywords] : newKeywords;
    setKeywords(kw);
    return () => unsetKeywords(kw);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return keywords;
};

export default useHelpKeywords;
